"use client";
import { title } from "@/components/primitives";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownSection,
  DropdownItem,
} from "@heroui/dropdown";

import { Button } from "@heroui/button";
import { Form } from "@heroui/form";
import { Input } from "@heroui/input";

export default function ObstacleCourse() {
  return (
    <div>
      <h1 className={title()}>Překážková dráha</h1>
    </div>
  );
}

